import { h } from 'preact';
import { isFocusStudio, getCurrentRegionCode } from 'utils/studioConfig';

import UniversalAboutEditor from 'components/editor/pages/about/aboutUniversal';
import UniversalAboutTimelineEditor from 'components/editor/pages/about/timeline/timeline';
import FocusAboutEditor from 'components/editor/pages/about/aboutFocus';

export default (props) => {
	if (isFocusStudio()) {
		return <FocusAboutEditor {...props} />;
	}
	if (getCurrentRegionCode() === 'us') {
		return <UniversalAboutTimelineEditor {...props} />;
	}
	return <UniversalAboutEditor {...props} />;
};
